const getPeerius = state => state.peerius || {};
const getClientName = state => getPeerius(state).clientName;
const getTrackerUrl = state => getPeerius(state).trackerUrl;
const getPageType = state => getPeerius(state).pageType;
const getLanguage = state => getPeerius(state).language;
const getProductCode = state => getPeerius(state).productCode;
const getBreadcrumbs = state => getPeerius(state).breadcrumbs;
const getSearchTerm = state => getPeerius(state).searchTerm;
const getSearchTotalNumber = state => getPeerius(state).searchTotalNumber;
const getSearchPageNumber = state => getPeerius(state).searchPageNumber;
const getSearchOnPageNumber = state => getPeerius(state).searchOnPageNumber;
const getSearchFilters = state => getPeerius(state).searchFilters || [];
const getSearchTopResultsCodes = state => getPeerius(state).searchTopResultsCodes;
const getBrand = state => getPeerius(state).brand;
const getRecommendationsByPosition = (state, position) =>
    (_getRecommendationsByWidgets(state) && _getRecommendationsByWidgets(state)[position]) || {};
const getShownImpressions = state => getPeerius(state).shownImpressions;
const getInitializationState = state => getPeerius(state).initialized;

const _getRecommendationsByWidgets = state => getPeerius(state).recommendationsByWidgets;

const isSmartContentRecommendationsReady = state => getPeerius(state).isSmartContentReady;
const getSmartContent = state => getPeerius(state).smartContent || {};
const getSmartContentByPosition = (state, pos) =>
    (getSmartContent(state) && getSmartContent(state)[pos]) || {};

export default {
    getClientName,
    getTrackerUrl,
    getPageType,
    getLanguage,
    getProductCode,
    getBreadcrumbs,
    getSearchTerm,
    getSearchTotalNumber,
    getSearchPageNumber,
    getSearchOnPageNumber,
    getSearchFilters,
    getSearchTopResultsCodes,
    getBrand,
    getRecommendationsByPosition,
    getShownImpressions,
    getInitializationState,
    isSmartContentRecommendationsReady,
    getSmartContent,
    getSmartContentByPosition,
};
